import axios from "axios";

export const server = {
  API_URL: "https://backendbutiko.com/api/",
  //API_URL: "http://127.0.0.1:8000/api/",
  // API_URL: "https://enviossendiback.azurewebsites.net/api/",
};
export const directionUsa = {
  nombre: "“Tu nombre”",
  direccion: "11751 SW 103RD LN CODE 169",
  ciudad: "MIAMI",
  estado: "Florida",
  zipCode: "33186",
  pais: "Estados Unidos",
  telefono: "(202) 977-3377",
};

// Mapea la respuesta del servicio de casilleros (client/legacy/locker) al esquema
// de directionUsa. Cualquier campo ausente cae al valor por defecto (directionUsa).
export function mapLegacyDirection(resp) {
  const body = resp?.data?.body ?? {};
  const data = body?.legacy?.data ?? {};
  // c_city viene combinado "Ciudad, ESTADO": separar por la primera coma.
  const [ciudad, estado] = String(data.c_city ?? "")
    .split(",")
    .map((s) => s.trim());
  return {
    locker: body.locker ?? data.locker ?? null,
    direction: {
      nombre: directionUsa.nombre, // el servicio no devuelve nombre
      direccion: data.locker_address ?? directionUsa.direccion,
      ciudad: ciudad || directionUsa.ciudad,
      estado: estado || directionUsa.estado,
      zipCode: data.c_postal ?? directionUsa.zipCode,
      pais: data.c_country ?? directionUsa.pais,
      telefono: data.c_phone ?? directionUsa.telefono,
    },
  };
}

// Obtiene la dirección del casillero por email. Nunca lanza: ante email vacío,
// error de red o usuario sin casillero, retorna la dirección por defecto.
export async function getLockerDirection(email) {
  if (!email) {
    return { locker: null, direction: directionUsa };
  }
  try {
    const resp = await axios.get(
      server.API_URL + "client/legacy/locker?email=" + encodeURIComponent(email)
    );
    return mapLegacyDirection(resp);
  } catch (error) {
    console.log("Error obteniendo el casillero: ", error);
    return { locker: null, direction: directionUsa };
  }
}
